import React, { useEffect, useState, useRef } from "react";
// Chakra imports
import {
    Flex,
    FormControl,
    FormLabel,
    Progress,
    Switch,
    Text
} from "@chakra-ui/react";
// react icons
import useGetMechanics from "hooks/useGetMechanics";

function EstimateMechanic({
    orderMechanics,
    setOrderMechanics
}) {

    let { 
        mechanics, 
        setGettingMechanics, 
        gettingMechanics, 
        gettingMechanicsReqSuccess 
    } = useGetMechanics({ page: 1, limit: 3000 });

    useEffect(() => {
        setGettingMechanics(true);
    }, []);

    const onToggleMechanic = (mechanic, checked) => {
        // console.log(mechanic);
        const orderMechanicsIds = orderMechanics.map(s => s.id);
        
        if (checked && !orderMechanicsIds.includes(mechanic.id)) {
            const tmp = [...orderMechanics];
            const tmpMechanic = {
                ...mechanic
            }
            tmp.push(tmpMechanic);
            setOrderMechanics(tmp);
            // console.log(tmp);
        } else if (!checked && orderMechanicsIds.includes(mechanic.id)) {
            const tmp = orderMechanics.filter(os => os.id !== mechanic.id);
            setOrderMechanics(tmp);
            // console.log(tmp);
        }

    }

    return (
        <FormControl marginBottom="12px">

            <Text fontSize="sm" color="gray.400" fontWeight="bold" mb={4}>
              SELECT MECHANIC
            </Text>
            {   gettingMechanics
                ? <Progress isIndeterminate />
                : <Flex flexDirection="column" w="100%" maxH="200px" overflow="auto">
                    {   mechanics.map((mechanic, sIndex) => {
                            return <Flex direction="column" w="100%" key={`mechanic-toggle-${sIndex}`}>
                                <FormControl display="flex" alignItems="center">
                                    <Switch 
                                        defaultChecked={orderMechanics.map(om => om.id).includes(mechanic.id)}
                                        colorScheme="teal" 
                                        me="10px" 
                                        onChange={(e) => onToggleMechanic(mechanic, e.target.checked)}
                                    />
                                    <FormLabel
                                        mb="0"
                                        ms="1"
                                        fontWeight="normal"
                                        >
                                        {mechanic.fullName 
                                            ? `${mechanic.fullName}` 
                                            : `${mechanic.firstName} ${mechanic.lastName}`
                                        }
                                        
                                    </FormLabel>
                                </FormControl>
                                
                            </Flex>
                        })
                    }
                </Flex>
            }
        </FormControl>
    );
}


export default EstimateMechanic;